module.exports = {"headerTitle":{"fontSize":"16","bold":"true"},"cardTitle":{"fontSize":"14","bold":"true"},"textCell":{"fontSize":"10"},"numericCell":{"alignment":"right","fontSize":"10"},"headerCell":{"bold":"true","fontSize":"12"},"pageNumberFooter":{"fontSize":"10"}}


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/pdf/pdf-doc-styles.json
// module id = sUjQ
// module chunks = 0